export { NetworkId as Network } from 'thales-utils'
